<template>
    <div v-if="showModal" id="parcel_modal_add" class="ui middle aligned center aligned grid">
        <div class="ui column segments">
            <div id="header" class="ui left aligned segment">
                <h3 class="ui header">택배발주 단건 추가</h3>
            </div>
            <div id="body" class="ui segment">
                <div class="ui form">
                    <div class="two fields">
                        <div class="field">
                            <label class="ui left aligned header">운송장번호</label>
                            <input type="number" v-model="item.number" placeholder="운송장번호" autocomplete=off>
                        </div>
                        <div class="field">
                            <label class="ui left aligned header">판매처</label>
                            <input type="text" v-model="item.seller" placeholder="판매처" autocomplete=off>
                        </div>
                    </div>
                    <div class="two fields">
                        <div class="field">
                            <label class="ui left aligned header">타입</label>
                            <select class="ui simple dropdown" v-model="item.type">
                                <option :value="constant.TYPE_PARCEL">택배</option>
                                <option :value="constant.TYPE_EXCHANGE">교환</option>
                                <option :value="constant.TYPE_RECALL">회수</option>
                                <option :value="constant.TYPE_AS">A/S</option>
                                <option :value="constant.TYPE_COUPANG">쿠팡</option>
                            </select>
                        </div>
                        <div class="field">
                            <label class="ui left aligned header">주문날짜</label>
                            <div class="ui calendar" id="add_parcel_orderedAt">
                                <div class="ui input left icon">
                                    <i class="calendar icon"></i>
                                    <input type="text" placeholder="주문날짜 선택">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="two fields">
                        <div class="field">
                            <label class="ui left aligned header">상품</label>
                            <div id="add_parcel_product" class="ui fluid search selection dropdown">
                                <input type="hidden" id="product_input">
                                <i class="dropdown icon"></i>
                                <div class="default text">상품 선택</div>
                                <div class="menu">
                                </div>
                            </div>
                        </div>
                        <div class="field">
                            <label class="ui left aligned header">수량</label>
                            <input type="number" v-model="item.count" autocomplete=off>
                        </div>
                    </div>
                    <div class="two fields">
                        <div class="field">
                            <label class="ui left aligned header">주문자</label>
                            <input type="text" v-model="item.orderer" placeholder="주문자 이름" autocomplete=off>
                        </div>
                        <div class="field">
                            <label class="ui left aligned header">주문자 전화번호</label>
                            <input type="text" v-model="item.ordererTel" placeholder="010-1234-5678" autocomplete=off>
                        </div>
                    </div>
                    <div class="two fields">
                        <div class="field">
                            <label class="ui left aligned header">수취인</label>
                            <input type="text" v-model="item.receiver" placeholder="수취인 이름" autocomplete=off>
                        </div>
                        <div class="field">
                            <label class="ui left aligned header">수취인 전화번호</label>
                            <input type="text" v-model="item.receiverTel" placeholder="010-1234-5678" autocomplete=off>
                        </div>
                    </div>
                    <div class="field">
                        <label class="ui left aligned header">주소</label>
                        <input type="text" v-model="item.address" autocomplete=off>
                        <div class="ui fluid teal basic button" @click="searchAddress">주소 검색</div>
                    </div>
                    <div class="field">
                        <label class="ui left aligned header">고객요청사항</label>
                        <input type="text" v-model="item.clientMemo" placeholder="고객요청사항" autocomplete=off>
                    </div>
                    <div class="field">
                        <label class="ui left aligned header">메모(설치유형)</label>
                        <input type="text" v-model="item.partnerMemo" placeholder="메모(설치유형)" autocomplete=off>
                    </div>
                </div>
            </div>
            <div id="footer" class="ui right aligned segment">
                <div class="ui primary button" @click="save">추가</div>
                <div class="ui button" @click="close">닫기</div>
            </div>
        </div>
    </div>
</template>

<script>

const openSearchAddressPopup = (onComplete) => {
    new daum.Postcode({
        oncomplete: function(data) {
            onComplete(data);
        }
    }).open();
};

export default {
    data: function() {
        return { showModal: 0, partner: 0, partnerProducts: 0, item: 0, onAdd: 0 }
    },
    created: function() {
        this.showModal = false;
    },
    mounted: function() {
        this.$event.set("open_add_parcel", this.open);
    },
    beforeDestroyed: function() {
        this.$event.clear("open_add_parcel");
    },
    methods: {
        open(partner, onAdd) {
            this.showModal = true;
            this.partner = partner;
            this.partnerProducts = this.findProducts(partner._id);
            this.onAdd = onAdd;
            this.item = {
                seller: "",
                type: this.constant.TYPE_DELIVERY,
                count: 1,
                clientMemo: "",
                partnerMemo: "",
            };
            this.$nextTick(() => {
                this.$ui.calendar("#add_parcel_orderedAt", (date, text) => { this.item.orderedAt = text; });
                this.$ui.dropdown("#add_parcel_product", (value) => { this.item.product = value; });
                this.$ui.setDropdownValues("#add_parcel_product", this.partnerProducts.map((p) => { return { name: p.name, value: p.name }; }));
            });
        },
        close() {
            this.showModal = false;
        },
        save() {
            if (this.checkError()) {
                this.item.orderedAt = new Date(this.item.orderedAt);
                this.onAdd(this.item);
                this.close();
            }
        },
        checkError() {
            if (!this.item.type) { alert("타입을 입력하세요!"); return; }
            if (!this.item.orderedAt) { alert("주문날짜를 입력하세요!"); return; }
            if (!this.item.product) { alert("상품 이름을 입력하세요!"); return; }
            if (!this.item.count) { alert("상품 수량을 입력하세요!"); return; }
            if (!this.item.orderer) { alert("주문자 이름를 입력하세요!"); return; }
            if (!this.item.ordererTel) { alert("주문자 전화번호를 입력하세요!"); return; }
            if (!this.item.receiver) { alert("수취인 이름을 입력하세요!"); return; }
            if (!this.item.receiverTel) { alert("수취인 전화번호를 입력하세요!"); return; }
            if (!this.item.address) { alert("주소를 입력하세요!"); return; }
            return true;
        },
        searchAddress() {
            openSearchAddressPopup((data) => {
                this.item.address = data.address;
                this.$forceUpdate();
            });
        },
        findProducts(_partnerId) {
            const array = [];
            for (const product of this.products) {
                if (product._partner == _partnerId) {
                    array.push(product);
                }
            }
            return array;
        },
    },
    computed: {
        centers: function() { return this.$store.getters.centers; },
        partners: function() { return this.$store.getters.partners; },
        constant: function() { return this.$store.getters.constant; },
        products: function() { return this.$store.getters.products; },
    },
}
</script>

<style>
#parcel_modal_add {
    position: fixed;
    left: 0;
    top: 0;
    margin: 0;
    z-index: 1;
    width: 100%;
    height: 100%;
    overflow: auto;
    background-color: rgba(0,0,0,0.8);
}

#parcel_modal_add .column {
    max-width: 700px;
}

#parcel_modal_add #header {
    padding: 20px 30px;
}

#parcel_modal_add #body {
    padding: 50px;
}

#parcel_modal_add #body .ui.form {
    padding: 10px;
}

#parcel_modal_add #footer {
    padding: 20px 20px;
    background-color: #eee;
}

#parcel_modal_add .ui.form {
    padding: 30px;
}
</style>


// WEBPACK FOOTER //
// src/components/ParcelOrderModal_Add.vue